import { render, staticRenderFns } from "./SuccessRestore.vue?vue&type=template&id=112a4d5f&"
import script from "./SuccessRestore.vue?vue&type=script&lang=ts&"
export * from "./SuccessRestore.vue?vue&type=script&lang=ts&"
import style0 from "./SuccessRestore.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports